import styled, { keyframes } from "styled-components";
import { CSSVars } from "../../styles/styles.config";

const gentleBounce = keyframes`
	0%, 100% { transform: translateY(0); }
	50% { transform: translateY(-2px); }
`;

const sparkle = keyframes`
	0%, 100% { opacity: 1; transform: scale(1); }
	50% { opacity: 0.6; transform: scale(1.2); }
`;

const christmasGradient = keyframes`
	0% { background-position: 0% 50%; }
	50% { background-position: 100% 50%; }
	100% { background-position: 0% 50%; }
`;

export const StyledHeader = styled.header`
	align-items: center;
	height: 80px;
	padding: 0 20px;
	text-align: left;
	display: none;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: auto;
	z-index: 99999;
	transform: translateY(-100px);
	transition: transform 0.3s ease;

	&.visible {
		transform: translateY(0);
		background: rgba(5, 5, 5, 0.65);
		backdrop-filter: blur(14px);
		-webkit-backdrop-filter: blur(14px);
		border: 1px solid rgba(255, 255, 255, 0.08);
		box-shadow: 0 10px 40px rgba(0, 0, 0, 0.45);
		margin: 10px auto;
		width: 97%;
		left: 1.5%;
		border-radius: 17px;
	}

	&:not(.in-on-top) {
		background: rgba(5, 5, 5, 0.65);
		backdrop-filter: blur(14px);
		-webkit-backdrop-filter: blur(14px);
		border: 1px solid rgba(255, 255, 255, 0.08);
		box-shadow: 0 10px 40px rgba(0, 0, 0, 0.45);
		margin: 10px auto;
		width: 97%;
		left: 1.5%;
		border-radius: 17px;
		position: fixed;
	}

	&.in-on-top {
		position: absolute;
		transform: translateY(0);
	}

	&.fix-position {
		position: relative;
		transform: translateY(0);
		margin: 0;
	}

	&.add-background {
		background: rgb(9, 10, 59);
		background: linear-gradient(
			90deg,
			rgba(9, 10, 59, 1) 0%,
			rgba(1, 1, 1, 1) 9%
		);
	}

	&.light-mode {
		background-color: ${CSSVars.white};
		box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.3);
		&.in-on-top {
			box-shadow: none;
		}
		nav .links-divider {
			a,
			.link,
			.section-label {
				color: ${CSSVars.black};
			}

			.login {
				border-color: ${CSSVars.black};
			}

			.start-creating {
				color: ${CSSVars.white};
			}
		}

		.company,
		.community,
		.apps {
			a:hover {
				background: linear-gradient(
					269deg,
					rgba(76, 79, 255, 0) 0%,
					rgba(76, 79, 255, 0.25) 100%
				);
			}
		}
	}

	@media screen and (min-width: ${CSSVars.breakpointMD}) {
		padding: 20px 30px;
	}

	@media screen and (min-width: 1100px) {
		display: flex;
	}

	nav {
		width: 1320px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 15px;
		
		a {
			color: ${CSSVars.white};
		}

		.links-divider {
			display: flex;
			align-items: center;

			.links {
				align-items: center;
				gap: 30px;
				margin-left: 30px;
				display: flex;

				.link-wrapper {
					position: relative;

					&::before {
						content: '';
						position: absolute;
						top: 100%;
						left: 0;
						width: 100%;
						height: 15px;
					}
				}
			}

			&.right-side {
				gap: 30px;
			}

			// main links style
			a,
			.link,
			.section-label {
				color: ${CSSVars.white};
				font-weight: 300;
				transition: 0.2s;

				&.section-label {
					display: flex;
					align-items: center;
					justify-content: center;
					gap: 5px;

					&:hover,
					&.show {
						color: ${CSSVars.blue400};
					}
				}

				&.login {
					position: relative;
					font-weight: 400;
					padding-bottom: 1px;

					&::before {
						content: '';
						position: absolute;
						top: calc(100% + 2px);
						left: 0;
						width: 0;
						height: 1px;
						border-radius: 5px;
						background-color: ${CSSVars.blue400};
						transition: 0.3s;
					}

					&:hover {
						color: ${CSSVars.blue400};

						&::before {
							width: 100%;
						}
					}
				}

				&.start-creating {
					border-radius: 8px;
					padding: 6px 20px;
					border: 1px solid ${CSSVars.blue500};
					background: ${CSSVars.blue500};
					color: ${CSSVars.white};
					font-weight: 400;
					transition: all 0.2s;

					&:hover {
						background: linear-gradient(270deg, #ff979c 0%, #4c4fff 100%);
						border-color: transparent;
						box-shadow: 0 4px 18px rgba(76, 79, 255, 0.45);
						transform: translateY(-1px);
					}

					@media (prefers-reduced-motion: reduce) {
						&:hover {
							transform: none;
						}
					}
				}

				&.advent-calendar-btn {
					display: flex;
					align-items: center;
					gap: 6px;
					padding: 6px 16px;
					border-radius: 20px;
					background: #000;
					/* background: linear-gradient(135deg, #50b9f2 0%, #1071a6 100%); */
					/* background-size: 200% 200%; */
					/* animation: ${christmasGradient} 4s ease infinite; */
					border: 1px solid ${CSSVars.blue500};
					color: #fff;
					font-weight: 500;
					font-size: 13px;
					position: relative;
					overflow: hidden;
					transition: all 0.3s ease;
					box-shadow: 0 0 15px rgba(80, 185, 242, 0.3);

					&::before {
						content: '';
						position: absolute;
						top: 0;
						left: -100%;
						width: 100%;
						height: 100%;
						background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
						transition: left 0.5s ease;
					}

					.advent-icon {
						font-size: 14px;
						animation: ${gentleBounce} 2s ease-in-out infinite;
					}

					.advent-text {
						color: #fff;
						text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
					}

					.advent-sparkle {
						font-size: 12px;
						animation: ${sparkle} 1.5s ease-in-out infinite;
					}

					&:hover {
						transform: translateY(-2px);
						box-shadow: 0 4px 25px rgba(80, 185, 242, 0.45);
						/* border-color: rgba(255, 255, 255, 0.6); */

						&::before {
							left: 100%;
						}
					}

					&:active {
						transform: translateY(0);
					}
				}

				&.logo {
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
		}
	}
`;

export const StyledMiniHeader = styled.header`
	@media screen and (min-width: 1100px) {
		display: none;
	}

	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: auto;
	z-index: 99999;
	transform: translateY(-100px);
	transition: transform 0.3s ease;

	&.visible {
		transform: translateY(0);
		background: rgba(5, 5, 5, 0.65);
		backdrop-filter: blur(14px);
		-webkit-backdrop-filter: blur(14px);
		border: 1px solid rgba(255, 255, 255, 0.08);
		box-shadow: 0 10px 40px rgba(0, 0, 0, 0.45);
		margin: 10px auto;
		width: 97%;
		left: 1.5%;
		border-radius: 17px;
	}

	&:not(.in-on-top) {
		background: rgba(5, 5, 5, 0.65);
		backdrop-filter: blur(14px);
		-webkit-backdrop-filter: blur(14px);
		border: 1px solid rgba(255, 255, 255, 0.08);
		box-shadow: 0 10px 40px rgba(0, 0, 0, 0.45);
		margin: 10px auto;
		width: 97%;
		left: 1.5%;
		border-radius: 17px;
		position: fixed;
	}

	&.add-background {
		background: rgb(9, 10, 59);
		background: linear-gradient(
			90deg,
			rgba(9, 10, 59, 1) 0%,
			rgba(1, 1, 1, 1) 9%
		);
	}

	&.in-on-top {
		position: absolute;
		top: 100px;
		transform: translateY(-100px);
		transition-duration: 0.05s;
	}

	&.fix-position {
		position: relative;
		transform: translateY(0);
		margin: 0;
	}

	nav {
		margin: 0 auto;
		height: 60px;
		padding: 0 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		max-width: 1580px;

		.logo {
			display: flex;
		}

		.hamburger {
			cursor: pointer;
			color: ${CSSVars.gray600};
			transition: 0.2s;
		}
	}
`;

export const StyledAside = styled.aside`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 270px;
  z-index: 99999;
  background-color: ${CSSVars.black};
  padding: 25px;

  transition: 0.2s;
  transform: translateX(-270px);

  &.opened {
    transform: translateX(0);

    @media screen and (min-width: 1100px) {
      transform: translateX(-270px);
    }
  }

  text-align: left;
  display: grid;
  grid-template-rows: 50px 1fr max-content;
  grid-template-areas:
    "top"
    "content"
    "bottom";

  .top {
    grid-area: top;
    height: 100px;
  }
  .content {
    grid-area: content;
    width: 100%;
    overflow: auto;

    // opened links
    nav {
      display: flex;
      flex-direction: column;
      gap: 2px;
      width: 100%;

      a {
        padding: 5px 10px;
        border-radius: 5px;
        transition: 0.2s;
        color: ${CSSVars.white};

        &.active,
        &:hover {
          background: linear-gradient(
            269deg,
            rgba(76, 79, 255, 0) 0%,
            rgba(76, 79, 255, 0.6) 100%
          );
        }
      }

      .sub-items {
        .title {
          padding-left: 10px;
          margin: 15px 0 5px;
          font-size: ${CSSVars.fontSizeXS};
          color: ${CSSVars.gray400};
          font-weight: 500;
        }

        .items {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
  .bottom {
    grid-area: bottom;
    display: flex;
    flex-direction: column;
    gap: 15px;

    padding: 20px 0;
    a {
      color: white;
    }

    .advent-calendar-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      padding: 10px 16px;
      border-radius: 20px;
			background: #000;
      /* background: linear-gradient(135deg, #50b9f2 0%, #1071a6 100%); */
      /* background-size: 200% 200%; */
      /* animation: ${christmasGradient} 4s ease infinite; */
      border: 1px solid ${CSSVars.blue500};
      color: #fff;
      font-weight: 500;
      font-size: 14px;
      text-align: center;
      transition: all 0.3s ease;
      box-shadow: 0 0 15px rgba(80, 185, 242, 0.3);

      &:hover {
        box-shadow: 0 4px 25px rgba(80, 185, 242, 0.45);
        /* border-color: rgba(255, 255, 255, 0.6); */
      }
    }

    .start-creating {
      border-radius: 8px;
      padding: 6px 20px;
      width: max-content;
      border: 1px solid ${CSSVars.blue500};
      background: ${CSSVars.blue500};

      &:hover {
        background: linear-gradient(270deg, #ff979c 0%, #4c4fff 100%);
        border-color: transparent;
      }
    }
  }

  img {
    cursor: pointer;
  }
`;
